module.exports = __webpack_public_path__ + "assets/images/facebook.png";